module.exports = __webpack_public_path__ + "img/new-zealand.89d73bce.svg";